/**
 * selectionBranchesService — the customer-facing list of active cell-selection
 * branches (the Hero / Cell-Selection chips). Branches are DB-driven, so a
 * branch added or disabled in the admin AI Flows area is reflected here with no
 * deploy. Returns [] on any error so callers fall back to their curated list.
 */
import { authenticatedFetch } from './authService.js'
import { getApiBase } from '../components/admin/analytics/shared/formatters.js'

export async function getSelectionBranches() {
  try {
    const res = await authenticatedFetch(`${getApiBase()}/chat/selection-branches`)
    if (!res.ok) return []
    const data = await res.json()
    return Array.isArray(data?.branches) ? data.branches : []
  } catch {
    return []
  }
}
